import React from 'react';

/**
 * The six-turn hero. It promises only what the flow delivers (#580): no score,
 * no Pass Plan email. Kept short so turn 1's answers start above the fold on an iPhone SE.
 */
export const SixTurnIntro: React.FC = () => (
  <div
    className="mb-4 rounded-2xl px-5 py-4 sm:p-7 text-white"
    style={{ backgroundColor: '#2C5F5D', boxShadow: '0 6px 0 rgba(17,17,17,0.12)' }}
    data-testid="six-turn-intro"
  >
    <p className="eyebrow text-white/70 mb-1.5">Free · no account · reviewed by a practicing LCSW</p>
    <h1 className="font-display font-bold text-white text-[22px] sm:text-3xl leading-tight mb-1.5">
      Try the real thing before you sign up.
    </h1>
    <p className="text-white/80 text-sm sm:text-base leading-snug">
      Six quick turns: practice questions that adapt to you, a clinical simulation, a flashcard, and a question for Pam.
    </p>
  </div>
);
